import { ApiError, request } from "./client";
import type {
  CreateIngestKeyInput,
  DevicesResponse,
  IngestKey,
} from "./types";

// Registre des postes de TAWA (`/devices`, scope `tawa:device:admin`, rôle
// admin) : enregistrement, liste et révocation.
export async function listIngestKeys(): Promise<DevicesResponse> {
  return request<DevicesResponse>({
    method: "GET",
    url: "/devices",
  });
}

// Postes du salarié connecté (déduit du jeton), même forme que `/devices`,
// sans le rôle admin.
export async function listMyDevices(): Promise<DevicesResponse> {
  return request<DevicesResponse>({
    method: "GET",
    url: "/workers/devices",
  });
}

export async function createIngestKey(
  k: CreateIngestKeyInput,
): Promise<IngestKey> {
  return request<IngestKey>({
    method: "POST",
    url: "/devices/register",
    data: k,
  });
}

// `id` est l'identifiant du poste (UUID), pas son `key_id`.
export async function revokeIngestKey(id: string): Promise<void> {
  await request<void>({
    method: "POST",
    url: `/devices/${encodeURIComponent(id)}/revoke`,
  });
}

// Une clé publique ed25519 fait 32 octets, soit 44 caractères en base64 avec
// padding. Valider la forme avant l'envoi permet de dire « clé invalide » sur le
// champ plutôt que de renvoyer un 400 opaque.
export const ED25519_PUBLIC_KEY_B64 = /^[A-Za-z0-9+/]{43}=$/;

/**
 * Motif de refus d'un enrôlement. Les deux conflits partagent le 409 et se
 * distinguent par le code du backend : `duplicate` dit « c'est déjà fait »,
 * `revoked` dit « ce matériel est écarté définitivement ». Les confondre laisse
 * sans issue le porteur d'un poste retiré par erreur, à qui il faut dire de
 * générer une nouvelle clé. Chaque écran formule son message ; c'est le
 * couplage aux codes backend qui est partagé ici.
 */
export type IngestKeyRefusal = "duplicate" | "revoked" | "other";

export function ingestKeyRefusal(error: unknown): IngestKeyRefusal {
  if (!(error instanceof ApiError) || error.status !== 409) return "other";
  return error.code === "public key revoked" ? "revoked" : "duplicate";
}
